import { Injectable } from '@angular/core';

interface SubMenuSection {
  isOpen: boolean;
  menu?: Record<string, unknown>;
}

interface ShopMenuSection {
  isOpen: boolean;
  engagementRings: SubMenuSection;
  weddingRings: SubMenuSection;
  modernIrish: SubMenuSection;
  celtic: SubMenuSection;
  houseOfLor: SubMenuSection;
}

interface MenuState {
  isOpen: boolean;
  shop: ShopMenuSection;
  aboutUs: ShopMenuSection;
}

@Injectable({ providedIn: 'root' })
export class MobileMenuService {

  _state: MenuState = this._initializeMenuState();

  public get isOpen(): boolean {
    return this._state.isOpen;
  }

  public get state(): MenuState {
    return this._state;
  }

  openMenu(): void {
    this._state.isOpen = true;
  }

  closeMenu(): void {
    this._state.isOpen = false;
    setTimeout(() => {
      this._state = this._initializeMenuState();
    }, 300);
  }

  _initializeMenuState(): MenuState {
    return {
      isOpen: false,
      shop: {
        isOpen: false,
        engagementRings: {
          isOpen: false,
          menu: {}
        },
        weddingRings: {
          isOpen: false,
          menu: {}
        },
        modernIrish: {
          isOpen: false,
          menu: {}
        },
        celtic: {
          isOpen: false,
          menu: {}
        },
        houseOfLor: {
          isOpen: false,
          menu: {}
        },
      },
      aboutUs: {
        isOpen: false,
        engagementRings: {
          isOpen: false,
        },
        weddingRings: {
          isOpen: false,
          menu: {}
        },
        modernIrish: {
          isOpen: false,
          menu: {}
        },
        celtic: {
          isOpen: false,
          menu: {}
        },
        houseOfLor: {
          isOpen: false,
          menu: {}
        },
      }
    };
  }
}
